"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaidRoutes = void 0;
const route_1 = require("../route");
class PlaidRoutes extends route_1.Route {
    constructor() {
        super('plaid');
    }
    /**
     * Returns the necessary configuration to launch Plaid Link UI
     */
    linkConfig() {
        return this.get('/link_config');
    }
    /**
     * Saves Plaid Link UI analytics data
     */
    linkEvent(event) {
        return this.post('/link_event', { event });
    }
    /**
     * Saves Plaid Link UI analytics data
     */
    publicToken(metadata) {
        return this.post('/public_token', { metadata });
    }
}
exports.PlaidRoutes = PlaidRoutes;
//# sourceMappingURL=plaid.js.map